import { useState } from "react";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import AddNotification from "../../allRoles/admin/addNotification/AddNotification";
import useNotification from "../../firebase-files/hooks/useNotification";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { MDBCol, MDBRow, MDBCardText } from "mdb-react-ui-kit";
import Popup from "../../default-components/Popup";
import ReactSwitch from "react-switch";
import "./Notification.css";
import "react-loading-skeleton/dist/skeleton.css";

const Notification = () => {
  const { user } = useAuthContext();
  const { deleteNotification } = useNotification();

  const [expandedIds, setExpandedIds] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const isHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

  const handleShowMoreClick = (notificationId) => {
    setExpandedIds((prevIds) =>
      prevIds.includes(notificationId)
        ? prevIds.filter((id) => id !== notificationId)
        : [...prevIds, notificationId]
    );
  };

  const isExpanded = (notificationId) => expandedIds.includes(notificationId);

  const { documents: dbnotifications } = useCollection("notifications");

  const { updateDocument } = useFirestore("notifications");
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [notificationIdToDelete, setNotificationIdToDelete] = useState(null);

  const handleDeleteNotification = (notificationId) => {
    setNotificationIdToDelete(notificationId);
    setIsDeletePopupOpen(true);
  };

  const handleConfirmDeleteProduct = () => {
    if (notificationIdToDelete) {
      deleteNotification(notificationIdToDelete);
      setIsDeletePopupOpen(false);
      setNotificationIdToDelete(null);
    }
  };

  const handleToggleChange = async (notificationId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const updatedDocument = await updateDocument(notificationId, {
      status: newStatus,
    });
    if (updatedDocument && updatedDocument.success) {
      console.log("Notification status updated successfully");
    } else {
      console.error("Error updating notification status");
    }
  };

  // Role-based filter
  const filteredNotifications = dbnotifications
    ? dbnotifications.filter((notification) => {
        if (user && (user.role === "admin" || user.role === "superAdmin"))
          return true;
        if (notification.visibleFor === "all") return true;
        return notification.visibleFor === user.role;
      })
    : [];

  return (
    <div className="container" style={{ minHeight: "70vh" }}>
      <Popup
        showPopupFlag={isDeletePopupOpen}
        setShowPopupFlag={setIsDeletePopupOpen}
        msg="Are you sure you want to delete this notification?"
        setPopupReturn={(confirmed) => {
          if (confirmed) {
            handleConfirmDeleteProduct();
          }
        }}
      />
      <br />
      <div className="row notification_div_parent">
        {showModal && <AddNotification onClose={() => setShowModal(false)} />}
        <div className="d-flex justify-content-between">
          <div className="pg_header">
            <h2 className="p_title">Alert Center!</h2>
            <h4 className="p_subtitle">Your Notifications, Stay Updated</h4>
          </div>
          {user && (user.role === "admin" || user.role === "superAdmin") && (
            <div>
              <button className="btn_fill" onClick={() => setShowModal(true)}>
                Add Notification
              </button>
            </div>
          )}
        </div>
        <div>
          <br />
        </div>
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map((notification) => (
            <div className="col-12 col-md-6 col-lg-4" key={notification.id}>
              <div
                className={`propagentusersingle ${
                  isExpanded(notification.id) ? "showmore" : ""
                }`}
              >
                <div className="left">
                  <div>
                    <div className="img_div">
                      <img src="./assets/img/loudspeaker.jpg" alt="" />
                    </div>
                  </div>
                  <div className="text_part">
                    {/* Title */}
                    {isHTML(notification.heading) ? (
                      <h5
                        dangerouslySetInnerHTML={{
                          __html: notification.heading,
                        }}
                      ></h5>
                    ) : (
                      <h5 className="name">{notification.heading}</h5>
                    )}

                    {/* Description */}
                    <h6
                      className={`phone_number ${
                        isExpanded(notification.id) ? "expanded" : ""
                      }`}
                    >
                      {isHTML(notification.fullDetail) ? (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: notification.fullDetail,
                          }}
                        ></p>
                      ) : (
                        <p>{notification.fullDetail}</p>
                      )}
                    </h6>

                    {/* Offer Time */}
                    {notification.notificationType === "Offer" &&
                      notification.fromTime &&
                      notification.toTime && (
                        <p className="offer-time">
                          Offer Time: {notification.fromTime} -{" "}
                          {notification.toTime}
                        </p>
                      )}
                  </div>
                </div>

                <h4 className="notification_date">
                  <span>
                    {formatDistanceToNow(notification.createdAt.toDate(), {
                      addSuffix: true,
                    })}
                  </span>
                </h4>

                {notification?.fullDetail?.length > 110 && (
                  <h6
                    onClick={() => handleShowMoreClick(notification.id)}
                    className="expand_line pointer"
                  >
                    {isExpanded(notification.id) ? "see less" : "see more"}
                  </h6>
                )}
              </div>

              {/* Admin + Super Admin controls */}
              {user &&
                (user.role === "admin" || user.role === "superAdmin") && (
                  <div style={{ margin: "0px 0px 20px 15px" }}>
                    <MDBRow>
                      <MDBCol className="col-9">
                        <MDBCardText className="text-muted">
                          <div className="d-flex align-items-center mt-2">
                            <div>
                              <p
                                className="active-inactive-text"
                                style={{ color: "#F05B83" }}
                              >
                                Inactive
                              </p>
                            </div>
                            <ReactSwitch
                              checked={notification.status === "active"}
                              onChange={() =>
                                handleToggleChange(
                                  notification.id,
                                  notification.status
                                )
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                            <div>
                              <p
                                className="active-inactive-text"
                                style={{ color: "#149AA2" }}
                              >
                                Active
                              </p>
                            </div>
                          </div>
                        </MDBCardText>
                      </MDBCol>
                      <MDBCol className="col-3 d-flex justify-content-center mt-2">
                        <MDBCardText
                          onClick={() =>
                            handleDeleteNotification(notification.id)
                          }
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ fontSize: "23px", cursor: "pointer" }}
                          >
                            delete
                          </span>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </div>
                )}
            </div>
          ))
        ) : (
          <div>You have no notifications</div>
        )}
      </div>
    </div>
  );
};

export default Notification;
